export default {
  SET_CURRENT_OPPORTUNITY(state, data) {
    state.currentEditedOpportunity = data;
  },
  SET_LANGUAGES(state, data) {
    state.languages = data;
  },
};
